import {
  ActionType,
  ISecondSectionPayload,
  ISecondSectionResponse,
} from "models/dashboard/secondSection";

export const getSecondSectionDataAction = (payload: ISecondSectionPayload) => {
  return {
    type: ActionType.GET_SECOND_SECTION_DATA,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_SECOND_SECTION_DATA_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: ISecondSectionResponse) => {
  return {
    type: ActionType.GET_SECOND_SECTION_DATA_SUCCESS,
    payload,
  };
};
